import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useStyles } from './preview-confirm.step.style';

interface PreviewSectionProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  titleClassName?: string;
}

export const PreviewSection = ({ title, children, className, headerClassName, titleClassName }: PreviewSectionProps) => {
  const { classes, cx } = useStyles();
  return (
    <section className={cx(classes.section, className)}>
      <Box className={cx(classes.sectionHeader, headerClassName)}>
        <Typography
          variant="h6"
          className={cx(classes.sectionTitle, titleClassName)}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </section>
  );
};